var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8.25C11.6642 8.25 12 8.58579 12 9C12 9.41421 11.6642 9.75 11.25 9.75H6.75C6.33579 9.75 6 9.41421 6 9C6 8.58579 6.33579 8.25 6.75 8.25H11.25Z",
    fill: "#597592"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1874 14.6179C12.0217 15.4769 10.5795 15.9848 9.01824 15.9848C5.14217 15.9848 2 12.8542 2 8.99242C2 5.13061 5.14217 2 9.01824 2C12.8943 2 16.0365 5.13061 16.0365 8.99242C16.0365 10.5782 15.5067 12.0406 14.6138 13.2137L17.7068 16.2953C18.098 16.6851 18.0975 17.3176 17.7062 17.7074C17.315 18.0972 16.6801 18.0977 16.2889 17.7079L13.1874 14.6179ZM14.0314 8.99248C14.0314 11.7509 11.787 13.9871 9.0184 13.9871C6.24978 13.9871 4.00537 11.7509 4.00537 8.99248C4.00537 6.23405 6.24978 3.99789 9.0184 3.99789C11.787 3.99789 14.0314 6.23405 14.0314 8.99248Z",
    fill: "#597592"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoomOut);
export default __webpack_public_path__ + "static/media/icon-zoom-out.3dd73a6e9df98fcf50f0cb223d26e947.svg";
export { ForwardRef as ReactComponent };